import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { HirePackageModalComponent } from '../../../../app/home/paraEmpresas/packages/hire/content.component';
import { RemoveLineModalComponent } from '../../../../app/home/paraEmpresas/packages/removeLine/content.component';
import { PackagesService } from '../../../../app/services/packages.service';
import { AlertService } from '../../../../app/utils/alert.service';
import { DataPackPackage } from '../../../../app/models/dataPackPackage.model';
import { DataPackLine } from '../../../../app/models/dataPackLine.model';

  import * as _ from "lodash";

/**
 * @version $Id: content.component.ts 79366 2018-02-17 00:40:37Z thiago.h.neri $
 */
@Component({
  selector: 'packages',
  templateUrl: './content.template.html'
})
export class PackagesComponent implements OnInit {

  private packages: Array<DataPackPackage> = new Array<DataPackPackage>();
  private lines: Array<DataPackLine> = new Array<DataPackLine>();
  private filteredLines: Array<DataPackLine> = new Array<DataPackLine>();
  private selectedLines: Map<string, DataPackLine> = new Map<string, DataPackLine>();
  private selectedPackage: DataPackPackage;
  private filterValue: string = '';
  private sortingCriteria: string;
  private sortingAsc: boolean = true;
  private savePurchasePackages: boolean = true;

  constructor(private modal: NgbModal, private packagesService: PackagesService, private alertService: AlertService) {

  }

  ngOnInit() {
    this.loadView();
  }

  private loadView() {
    this.packagesService.loadView(1,50).subscribe(
      data => {
        this.selectedPackage = null;
        this.selectedLines.clear();
        this.packages = data['packages'];
        this.lines = data['lines'];
        this.filterLines();
      },
      err => {
        this.alertService.error(err.result, err);
      }
    );
  }

  private filterLines() {
    this.filteredLines = this.lines.filter(line => !this.filterValue || this.filterValue === '' || this.searchText(line.userName, this.filterValue) || this.searchText(line.lineNumber, this.filterValue));
  }

  private searchText(text: string, value: string) {
    return text ? text.toLowerCase().search(value.toLowerCase()) != -1 : false;
  }

  private sortLines(field: string) {
    this.sortingAsc = this.sortingCriteria == field ? !this.sortingAsc : true;
    this.sortingCriteria = field;
    this.lines = _.orderBy(this.lines, [this.sortingCriteria], [this.sortingAsc ? 'asc' : 'desc']);
  }

  private selectPackage(dataPackage: DataPackPackage) {
    this.selectedPackage = dataPackage;
  }

  private unselectPackage() {
    this.selectPackage = null;
  }

  private isHiring() {
   return this.selectedPackage && this.selectedLines.size > 0;
  }

  private isPackageSelected(dataPackage: DataPackPackage) {
    return this.selectedPackage && this.selectedPackage.name === dataPackage.name;
  }

  private selectLine(line: DataPackLine) {
    this.selectedLines.set(line.lineNumber, line);
  }

  private unselectLine(line: DataPackLine) {
    this.selectedLines.delete(line.lineNumber);
  }

  private isLineSelected(line: DataPackLine) {
    return this.selectedLines.has(line.lineNumber);
  }

  private getSelectedLines() {
    let lines = new Array<DataPackLine>();
    this.selectedLines.forEach((line) => {
      lines.push(line)
    });
    return lines;
  }

  private getPackageSize() {
    var valor:number = Number(this.selectedPackage.name.match(/\d+/g));
    if (valor >= 0 && valor != null){
      return (valor * this.selectedLines.size).toString()+ this.selectedPackage.name.replace(/[0-9]/g, '');
    }
    return '';
  }

  private getPackageCost() {
    let valor:number = Number(this.selectedPackage.value.replace(',','.'));
    valor = valor * this.selectedLines.size;
    return Number(valor).toFixed(2).toString().replace('.',',');
  }

  private hire() {
    let lines = new Array<DataPackLine>();
    this.selectedLines.forEach((line) => {
      lines.push(line);
    });

    let modalRef = this.modal.open(HirePackageModalComponent);
    modalRef.componentInstance.package = this.selectedPackage;
    modalRef.componentInstance.lines = lines;
    modalRef.componentInstance.totalCost = this.getPackageCost();
    modalRef.result.then(result => this.loadView(), reason => null);
  }

  private removeSelectedLine(line: DataPackLine) {
    let modalRef = this.modal.open(RemoveLineModalComponent);
    modalRef.componentInstance.line = line;
    modalRef.result.then(
      result => this.selectedLines.delete(line.lineNumber),
      reason => null
    );
  }
  private maskMsisdn(msisdn: string): string {
    if(_.isNil(msisdn)) {
      return ''; 
    }
    if(msisdn.length == 12) {
      return '('.concat(msisdn.substr(0,3)).concat(') ').concat(msisdn.substring(3,(msisdn.length -4))).concat('-').concat(msisdn.substr(-4,4));  
    } else if(msisdn.length == 11) {
      return '('.concat(msisdn.substr(0,2)).concat(') ').concat(msisdn.substring(2,(msisdn.length -4))).concat('-').concat(msisdn.substr(-4,4));
    } 
    return msisdn;
  }

}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/packages/content.component.ts